// Firebase service for common operations
import { 
  auth, 
  analytics 
} from '../config/firebase';

// Re-export Firebase services for easy importing
export { auth, analytics };

// Common Firebase operations
export const firebaseService = {
  // Get current user
  getCurrentUser: () => {
    return auth.currentUser;
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!auth.currentUser;
  },

  // Log analytics event
  logEvent: (eventName: string, parameters?: Record<string, any>) => {
    if (analytics) {
      // Import analytics functions dynamically to avoid SSR issues
      import('firebase/analytics').then(({ logEvent }) => {
        logEvent(analytics!, eventName, parameters);
      });
    }
  }

  // Note: Firestore operations removed since we're using PostgreSQL
  // If you need Firestore in the future, uncomment and add the imports:
  // 
  // import { getFirestore, collection, doc } from 'firebase/firestore';
  // 
  // getCollection: (collectionName: string) => {
  //   const db = getFirestore();
  //   return collection(db, collectionName);
  // },
  // 
  // getDocument: (collectionName: string, docId: string) => {
  //   const db = getFirestore();
  //   return doc(db, collectionName, docId);
  // }
};

export default firebaseService;
